/** Toast banner in the toolbar — port of banner(). */
let timer: ReturnType<typeof setTimeout> | null = null;

export function banner(msg: string, cls: "ok" | "warn" | "" = "", html = false) {
  const el = document.getElementById("verbanner");
  if (!el) return;
  el.style.display = "";
  el.className = "vb " + cls;
  if (html) el.innerHTML = msg;
  else el.textContent = msg;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    el.style.display = "none";
  }, html ? 60_000 : 12_000);
}

/** Dismiss the current banner immediately (e.g. the offline warning once the
 * connection is back). */
export function clearBanner() {
  const el = document.getElementById("verbanner");
  if (el) el.style.display = "none";
  if (timer) clearTimeout(timer);
}
